export const LAST_OPERATIONS_NUMBER = 4;

export const PAGE_SIZE = 10;

export const PAGE_NUMBER = 1;
